import React, { useState } from 'react';

// Signups go to the "JUCO Pipeline Site" email list in the juco-pipeline-2
// Outseta account, using that list's plain HTML signup form. It's posted in the
// background so visitors stay on the page. Browsers don't let us read Outseta's
// reply, so any request that reaches Outseta counts as a success.
const OUTSETA_LIST_URL = 'https://juco-pipeline-2.outseta.com/email/lists/pWrAVL9n/subscribe';
// Outseta's hidden anti-bot field from the same form code; it must be sent empty.
const OUTSETA_BOT_TRAP_FIELD = 'o_rbQ9F30CmW4wtfG8HZMYSdAO_O5ZrLJ0h';

const subscribe = async (email) => {
  const body = new URLSearchParams({ Email: email, [OUTSETA_BOT_TRAP_FIELD]: '' });
  await fetch(OUTSETA_LIST_URL, { method: 'POST', mode: 'no-cors', body });
};

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!EMAIL_PATTERN.test(email.trim())) {
      setStatus('invalid');
      return;
    }
    setStatus('submitting');
    try {
      await subscribe(email.trim());
      setStatus('success');
      setEmail('');
    } catch (error) {
      setStatus('error');
    }
  };

  // The band is navy in both themes, so its colors are fixed rather than tokens.
  const messages = {
    invalid: { text: 'Please enter a valid email address.', className: 'text-red-300' },
    error: { text: "Something went wrong. Please try again.", className: 'text-red-300' },
    success: { text: "You're in. Watch your inbox for the next issue.", className: 'text-cyan-300' },
  };
  const message = messages[status];

  return (
    <section className="bg-jp-page px-4 sm:px-6 lg:px-8 pb-16 sm:pb-20">
      <div className="max-w-7xl mx-auto rounded-2xl bg-jp-band border border-jp-gold/40 px-6 py-8 sm:px-10 sm:py-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div className="max-w-xl">
            <h2 className="text-xl sm:text-2xl font-extrabold text-white mb-2">
              Not ready to sign up? <span className="text-cyan-400">Stay in the loop.</span>
            </h2>
            <p className="text-slate-300 text-sm leading-relaxed">
              Weekly rankings, commitment alerts, and uncommitted players to watch, straight to your inbox.
            </p>
          </div>

          <form onSubmit={handleSubmit} noValidate className="w-full lg:w-[28rem] flex-shrink-0">
            <div className="flex flex-col sm:flex-row gap-2">
              <label htmlFor="newsletter-email" className="sr-only">
                Email address
              </label>
              <input
                id="newsletter-email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                  if (status !== 'submitting') setStatus('idle');
                }}
                placeholder="Enter your email"
                aria-invalid={status === 'invalid'}
                aria-describedby="newsletter-status"
                className="flex-1 min-w-0 px-4 py-2.5 rounded-full bg-white/10 border border-white/20 text-white text-sm placeholder-slate-400 focus:outline-none focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400/50 transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'submitting'}
                className="px-6 py-2.5 rounded-full bg-cyan-400 text-jp-navy text-sm font-bold uppercase tracking-wider hover:bg-cyan-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-200 focus-visible:ring-offset-2 focus-visible:ring-offset-jp-band transition-colors disabled:opacity-50"
              >
                {status === 'submitting' ? 'Subscribing…' : 'Subscribe'}
              </button>
            </div>
            <p
              id="newsletter-status"
              className={`text-xs mt-2 pl-4 min-h-[1rem] ${message ? message.className : 'text-slate-400'}`}
              role="status"
            >
              {message ? message.text : 'Free. Unsubscribe anytime.'}
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
